import { useAuth } from '../contexts/AuthContext';
import type { AppMode } from '../types';

interface Props {
  mode: AppMode;
  onReturnHome: () => void;
}

export default function Header({ mode, onReturnHome }: Props) {
  const { user, logout } = useAuth();

  const handleLogout = async () => {
    await logout();
    window.location.href = '/login';
  };

  return (
    <header className="header">
      <div className="header-left">
        <div className="brand-header">
          <img src="/brand/nwg-logo-small.png" alt="NextWealth Global — Show Us the Problems. We Build the Solutions." className="brand-logo" />
          <div>
            <h1 className="header-title">NextWealth™ Global</h1>
            <span className="header-sub">NWG Command Center</span>
          </div>
        </div>
      </div>
      <div className="header-right">
        {user && (
          <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
            <div style={{ fontSize: '12px', color: '#FFD700', opacity: 0.7 }}>
              {user.full_name} ({user.role})
            </div>
            <button
              className="header-btn"
              onClick={handleLogout}
              style={{
                padding: '8px 16px',
                background: 'rgba(255, 215, 0, 0.1)',
                border: '1px solid #FFD700',
                color: '#FFD700',
                cursor: 'pointer',
                borderRadius: '4px',
                fontSize: '12px',
              }}
            >
              LOGOUT
            </button>
          </div>
        )}
        {mode === 'active' && (
          <button className="header-btn" onClick={onReturnHome} data-testid="return-home">
            ← Return to Home
          </button>
        )}
        {mode === 'standby' && (
          <div className="header-status">
            <span className="status-dot"></span>
            <span>Standby</span>
          </div>
        )}
      </div>
    </header>
  );
}
